export default __webpack_public_path__ + "static/media/icon-about.a75b24b0.svg";